import React from "react";

const TrekThingsToCarry = () => {
  return (
    <div className="space-y-6 text-gray-800 text-sm md:text-base leading-relaxed">
      {/* Header */}
      <div>
        <h2 className="text-xl font-semibold mb-2">🎒 Things to Carry</h2>
        <p>
          Please ensure you pack the following items for a safe and comfortable
          trekking experience:
        </p>
      </div>

      {/* Essentials */}
      <div>
        <h3 className="text-lg font-medium mb-2">🧳 Essentials</h3>
        <ul className="list-disc list-inside space-y-1">
          <li>High-quality raincoat or poncho (essential during monsoons)</li>
          <li>Backpack with a reliable rain cover</li>
          <li>Water bottle (minimum 2 liters recommended)</li>
          <li>Dry snacks (energy bars, dry fruits, biscuits, etc.)</li>
          <li>Cap or hat (for sun and rain protection)</li>
          <li>Valid ID proof (Aadhar card or any government-issued ID)</li>
        </ul>
      </div>

      {/* Clothing & Footwear */}
      <div>
        <h3 className="text-lg font-medium mb-2">👕 Clothing & Footwear</h3>
        <ul className="list-disc list-inside space-y-1">
          <li>Quick-dry clothes (avoid heavy fabrics like denim)</li>
          <li>Full-sleeve t-shirts and trek pants for better protection</li>
          <li>Sturdy trekking shoes with good grip (avoid worn-out soles)</li>
          <li>Extra socks and change of clothes</li>
          <li>Small towel or napkin</li>
        </ul>
      </div>

      {/* Useful Extras */}
      <div>
        <h3 className="text-lg font-medium mb-2">🧰 Useful Extras</h3>
        <ul className="list-disc list-inside space-y-1">
          <li>
            Ziplock bags or plastic covers to keep electronics and clothes dry
          </li>
          <li>Sunscreen (even during cloudy days)</li>
          <li>
            Cash for personal expenses (many areas may not accept UPI/cards)
          </li>
          <li>Torch or headlamp with extra batteries</li>
          <li>Power bank to charge your devices</li>
          <li>Personal medications, if any</li>
          <li>Basic first aid (band-aids, antiseptic cream, etc.)</li>
          <li>
            Trekking pole (optional but helpful for steep or slippery trails)
          </li>
          <li>Small daypack to carry essentials during the trek</li>
          <li>Comfortable slippers or sandals for travel and campsite use</li>
        </ul>
      </div>

      {/* Final Note */}
      <div>
        <h3 className="text-lg font-medium mb-2">😄 And Most Importantly:</h3>
        <ul className="list-disc list-inside space-y-1">
          <li>✅ A big smile </li>
          <li>✅ Zero negativity</li>
        </ul>
      </div>
    </div>
  );
};

export default TrekThingsToCarry;
